module.exports = __webpack_public_path__ + "img/claim3.226e04e7.png";